module.exports = __webpack_public_path__ + "img/video-24.3122c23a.png";